import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { computeJourneyReadiness } from '../../../utils/journeyReadiness';

interface ReadinessStripProps {
    readiness: ReturnType<typeof computeJourneyReadiness>;
}

/** Plain-language pipeline status: what the award numbers are actually based on. */
const ReadinessStrip: React.FC<ReadinessStripProps> = ({ readiness }) => {
    const estimateOnly = readiness.quotedCount === 0;
    const bits: string[] = [];
    bits.push(`${readiness.shortlistedCount} supplier${readiness.shortlistedCount === 1 ? '' : 's'} shortlisted`);
    bits.push(readiness.quotedCount > 0
        ? `${readiness.quotedCount} quoted (${readiness.quotedSummary.join(', ')})`
        : 'none have quoted');
    if (readiness.negotiatingCount > 0) bits.push(`${readiness.negotiatingCount} in negotiation`);
    if (readiness.notContactedCount > 0) bits.push(`${readiness.notContactedCount} never contacted`);
    if (readiness.noEmailCount > 0) bits.push(`${readiness.noEmailCount} unreachable (no contact email)`);
    return (
        <div
            className={`flex items-start gap-s3 rounded-card border px-s5 py-s3 text-body-sm ${
                estimateOnly ? 'border-warn-border bg-warn-bg text-warn-ink' : 'border-line bg-surface text-ink-secondary'
            }`}
        >
            <ShieldAlert className={`mt-[1px] h-[13px] w-[13px] shrink-0 ${estimateOnly ? 'text-warn-ink' : 'text-ink-muted'}`} />
            <span>
                {bits.join(' · ')}.
                {estimateOnly && (
                    <> Prices below are research estimates — no supplier has committed a quote yet. Consider sending RFQs from Supplier Outreach first.</>
                )}
            </span>
        </div>
    );
};

export default ReadinessStrip;
